import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import fr from "./locales/fr.json";
import tr from "./locales/tr.json";
import ar from "./locales/ar.json";
import es from "./locales/es.json";
import sv from "./locales/sv.json";
import id from "./locales/id.json";
import fa from "./locales/fa.json";
import vi from "./locales/vi.json";
import he from "./locales/he.json";
import ko from "./locales/ko.json";
import hi from "./locales/hi.json";
import it from "./locales/it.json";
import pa from "./locales/pa.json";
import pt from "./locales/pt.json";
import ur from "./locales/ur.json";
import pl from "./locales/pl.json";
import ru from "./locales/ru.json";
import de from "./locales/de.json";
import ja from "./locales/ja.json";
import nl from "./locales/nl.json";
import bn from "./locales/bn.json";
import zh from "./locales/zh.json";

const resources = {
  en: { translation: en },
  fr: { translation: fr },
  tr: { translation: tr },
  ar: { translation: ar },
  es: { translation: es },
  sv: { translation: sv },
  id: { translation: id },
  fa: { translation: fa },
  vi: { translation: vi },
  he: { translation: he },
  ko: { translation: ko },
  hi: { translation: hi },
  it: { translation: it },
  pa: { translation: pa },
  pt: { translation: pt },
  ur: { translation: ur },
  pl: { translation: pl },
  ru: { translation: ru },
  de: { translation: de },
  ja: { translation: ja },
  nl: { translation: nl },
  bn: { translation: bn },
  zh: { translation: zh },
};

const preferred =
  (typeof localStorage !== "undefined" && localStorage.getItem("locale")) ||
  navigator.language?.split("-")?.[0] ||
  "en";

i18n.use(initReactI18next).init({
  resources,
  lng: preferred,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
